import React from 'react'
import { Text, Flex, Icon } from '@chilipiper/design-system'
import { SvgWarningTriangle } from '@chilipiper/icons'

interface Props {
  renderNoTimes?: boolean
  subtitle?: string
  title: string
}

export const NoAvailableTimeSlots = ({ renderNoTimes, title, subtitle }: Props) => {
  if (!renderNoTimes) {
    return null
  }
  return (
    <Flex
      data-test-id='NoAvailableTimeSlots'
      justifyContent='center'
      alignItems='center'
      mb={2}
      mt={4}
      flexDirection='column'
    >
      <Icon mb={5} w={6} h={6} icon={SvgWarningTriangle} color='yellow-dark-100' />
      <Text data-test-id='NoAvailableTimeSlots-title' color='neutral-dark-100' fontWeight={600}>
        {title}
      </Text>
      {subtitle ? (
        <Text data-test-id='NoAvailableTimeSlots-subtitle' color='neutral-dark-80' mt={2}>
          {subtitle}
        </Text>
      ) : null}
    </Flex>
  )
}
